module.exports = __webpack_public_path__ + "img/16.93e0335b.png";